import templateDefaults from '../templateDefaults';

const TGB_ASSETS_URL = process.env.TGB_ASSETS_CDN_URL;

export default {
  previewImage: '/img/sports/l3-two-lines.png',
  title: '2-Line Lower Third',
  templateData() {
    return {
      version: 'v1.1',
      title: 'Sports Lower Third 2 Line',
      ...templateDefaults,
      elements: [
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Headline',
          locked: false,
          text: '<p><strong>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur cursus metus turpis</strong></p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          fitText: true,
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 849,
            left: 169,
            width: 1138,
            height: 78,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 36,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Text',
          locked: false,
          text: '<p>SUBHEADLINE</p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          fitText: true,
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 973,
            left: 144,
            width: 1273,
            height: 30,
            opacity: 1,
            color: '#000000',
            fontFamily: 'Roboto Condensed',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 24,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Rectangle',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          border: true,
          borderWidth: 8,
          borderColor: 'rgb(255, 255, 255)',
          boxShadow: true,
          boxShadowX: -4,
          boxShadowY: 4,
          boxShadowBlur: 17,
          boxShadowSpread: 1,
          boxShadowColor: 'rgba(0, 0, 0, 0.49)',
          fillStyle: 'solid',
          backgroundColor: 'rgb(234, 188, 52)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 5,
          borderTopRightRadius: 5,
          borderBottomRightRadius: 5,
          borderBottomLeftRadius: 5,
          blur: false,
          blurSize: 10,
          skewX: -20,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 958,
            left: 102,
            width: 1392,
            height: 60,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'image',
          name: 'Team Logo 1',
          editable: true,
          locked: false,
          aspectLock: true,
          mask: false,
          maskShape: 'oval',
          imageUrl: `${TGB_ASSETS_URL}/logos/tagboard-hash-white.png`,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          fillType: 'stretch',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 849,
            left: 1389,
            width: 86,
            height: 75,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Team 2 BG',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          fillStyle: 'solid',
          backgroundColor: 'rgb(0, 90, 45)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          skewX: -20,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 837,
            left: 1354,
            width: 160,
            height: 102,
            opacity: '0.80',
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Highlight',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          border: false,
          borderWidth: 8,
          borderColor: 'rgb(255, 255, 255)',
          boxShadow: false,
          boxShadowX: -4,
          boxShadowY: 4,
          boxShadowBlur: 17,
          boxShadowSpread: 1,
          boxShadowColor: 'rgba(0, 0, 0, 0.51)',
          fillStyle: 'solid',
          backgroundColor: 'rgb(255, 255, 255)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: 'rgba(255, 255, 255, 0.72)',
          gradientColorTwo: 'rgba(255, 255, 255, 0.22)',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          skewX: 0,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 829,
            left: 130,
            width: 1728,
            height: 60,
            opacity: '0.20',
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Black Bar',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          border: true,
          borderWidth: 8,
          borderColor: 'rgb(255, 255, 255)',
          boxShadow: true,
          boxShadowX: -4,
          boxShadowY: 4,
          boxShadowBlur: 17,
          boxShadowSpread: 1,
          boxShadowColor: 'rgba(0, 0, 0, 0.51)',
          fillStyle: 'solid',
          backgroundColor: 'rgb(0, 0, 0)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
          borderBottomRightRadius: 10,
          borderBottomLeftRadius: 10,
          blur: false,
          blurSize: 10,
          skewX: -20,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 828,
            left: 128,
            width: 1394,
            height: 118,
            opacity: 1,
          },
        },
      ],
    };
  },
};
